import { forwardRef } from 'react';
import { Link } from 'react-router-dom';

const baseClasses =
  'inline-flex items-center justify-center gap-2 min-h-12 px-5 py-3 rounded-card font-bold tracking-normal transition-all duration-200 ease-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-signal';

const variants = {
  primary:
    'bg-gradient-to-br from-signal to-[#63d0f3] text-ink shadow-button hover:shadow-lg hover:-translate-y-0.5',
  secondary:
    'bg-white/10 text-white border border-white/40 backdrop-blur-sm hover:bg-white/20 hover:border-white/70',
  quiet:
    'bg-transparent text-ink border border-ink/10 hover:bg-paper-deep hover:border-signal',
  dark:
    'bg-gradient-to-br from-chat-accent to-chat-accent-strong text-white border border-white/15 shadow-button hover:shadow-lg hover:-translate-y-0.5',
  ghost: 'bg-transparent text-ink hover:bg-ink/5',
};

const Button = forwardRef(function Button(
  { variant = 'primary', to, href, className = '', children, ...props },
  ref
) {
  const classes = `${baseClasses} ${variants[variant] || variants.primary} ${className}`;

  if (to) {
    return (
      <Link ref={ref} to={to} className={classes} {...props}>
        {children}
      </Link>
    );
  }

  if (href) {
    return (
      <a ref={ref} href={href} className={classes} {...props}>
        {children}
      </a>
    );
  }

  return (
    <button ref={ref} className={classes} {...props}>
      {children}
    </button>
  );
});

export default Button;
